import styled from 'styled-components'

export const Container = styled.div(({ theme }) => ({
  padding: `${theme.space['20']} ${theme.space['24']}`,
}))

export const Instructions = styled.p(({ theme }) => ({
  color: theme.colors.black700,
  fontSize: '1.4rem',
  fontWeight: 400,
  lineHeight: '2rem',
  marginBottom: theme.space['24'],
  textAlign: 'center',
}))

export const CodeDisplay = styled.div(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.colors.gray100,
  borderRadius: theme.border.radius['8'],
  display: 'flex',
  justifyContent: 'center',
  padding: `${theme.space['24']} ${theme.space['32']}`,
}))

export const CodeValue = styled.span(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '3.6rem',
  fontWeight: 700,
  letterSpacing: '0.4rem',
}))
